import { render } from "./ToDoView.vue?vue&type=template&id=18fff280"
import script from "./ToDoView.vue?vue&type=script&lang=js"
export * from "./ToDoView.vue?vue&type=script&lang=js"

import "./ToDoView.vue?vue&type=style&index=0&id=18fff280&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__